import classnames from "classnames";
import isNumber from "lodash/isNumber";

import {TooltipIconRA} from "@/components/overlay/TooltipIconRA";
import {thousandSeparatedInt} from "@/lib/format.tsx";
import {Account} from "@/lib/types/accounts.ts";
import {AccountStats} from "@/lib/types/billing.ts";

export interface AccountUsageRowProps {
  name: string;
  helpText?: string;
  data: AccountStats[];
  className?: string;
}

export interface GenericAccountUsageRowProps extends AccountUsageRowProps {
  getterFn: (data: AccountStats) => string;
}

export const AccountUsageGenericRow = ({name, helpText, data, className, getterFn}: GenericAccountUsageRowProps) => {
  return (
    <tr>
      <td className={classnames(className, "pe-4 d-flex")} key="td-name">
        {name}:{helpText && <TooltipIconRA className="ms-1" title={helpText} />}
      </td>
      {data.map((dataSlice, idx) => (
        <td className="pe-4" key={`td-value-${idx}`}>
          {getterFn(dataSlice)}
        </td>
      ))}
    </tr>
  );
};

export interface AccountUsageStatRowProps extends AccountUsageRowProps {
  field: keyof AccountStats;
}
export const AccountUsageRowPair = (props: AccountUsageStatRowProps) => {
  const {field} = props;
  return (
    <AccountUsageGenericRow
      getterFn={(data) => {
        if (!data[field]) {
          return "";
        }
        const [used, avail] = data[field] as [number, number];
        if (!isNumber(used) || !isNumber(avail)) {
          return "";
        }
        return `${thousandSeparatedInt(used)} / ${thousandSeparatedInt(avail)}`;
      }}
      {...props}
    />
  );
};

export const AccountUsagePlainValueRow = (props: AccountUsageStatRowProps) => {
  const {field} = props;
  return <AccountUsageGenericRow getterFn={(data) => (data[field] || "").toString()} {...props} />;
};

export interface AccountUsageFeatureProps extends AccountUsageRowProps {
  field: keyof Account;
}
export const AccountUsageFeatureRow = (props: AccountUsageFeatureProps) => {
  const {field} = props;
  return (
    <AccountUsageGenericRow
      getterFn={(data) => (data.account ? (data.account[field] === true ? "Yes" : "No") : "")}
      {...props}
    />
  );
};
